import { useEffect, useState } from 'react';

type Options = {
  horizontally?: boolean;
  vertically?: boolean;
};

export const getIsOverflowing = (element: HTMLElement, { vertically, horizontally }: Options) => {
  const { clientWidth, scrollWidth, scrollHeight, clientHeight } = element;
  const isOverflowing = (horizontally ? clientWidth < scrollWidth : false) || (vertically ? clientHeight < scrollHeight : false);

  return isOverflowing;
};

export const useIsOverflowing = (element: HTMLElement | null, options: Options) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (!element) return;

    setIsOverflowing(getIsOverflowing(element, options));
  }, [setIsOverflowing, options, element]);

  return { isOverflowing };
};
